import { useState } from 'react';

import { useUpdateNoteMutation, useDeleteNoteMutation } from '../../../../../services/contacts';
import { trackEvent } from '../../../../../helpers/analytics';

export const useNote = ({ queryParams, contactId, note }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [updateNote, { isLoading: isLoadingUpdateNote }] = useUpdateNoteMutation();
  const [deleteNote, { isLoading: isLoadingDeleteNote }] = useDeleteNoteMutation();

  const onEdit = () => {
    setIsEditing(true);
  };

  const onSave = async (values) => {
    trackEvent('contacts:notes:edit', {
      origin: 'full_profile',
    });
    await updateNote({ queryParams, contactId, note, values });
    setIsEditing(false);
  };

  const onShowDeleteConfirmation = () => {
    setShowDeleteConfirmation(true);
  };

  const onDelete = () => {
    trackEvent('contacts:notes:delete', {
      origin: 'full_profile',
    });
    deleteNote({ queryParams, contactId, note });
  };

  return {
    isEditing,
    setIsEditing,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
    isLoadingUpdateNote,
    isLoadingDeleteNote,
    onEdit,
    onSave,
    onShowDeleteConfirmation,
    onDelete,
  };
};
